/**
 * Created by olga on 09.07.2026
 */

const RainbowComponent = function (unit) {
    UnitComponent.call(this, unit);
};

RainbowComponent.prototype = Object.create(UnitComponent.prototype);
RainbowComponent.prototype.constructor = RainbowComponent;

RainbowComponent.prototype.handleDragStart = function () {
    if (this.view) {
        this.view.highlightDrag();
    }
};

RainbowComponent.prototype.handleDragMove = function (rawX, rawY, handled) {
    const affected = handled ? undefined : this.findAffectedUnit(rawX, rawY, true);

    if (affected !== this.highlightedTarget) {
        this.unhighlightTarget();

        if (affected) {
            this.highlightedTarget = affected;
            affected.findComponent(MergeComponent).startMergeHighlight();
        }
    }

    return Boolean(affected);
};

RainbowComponent.prototype.unhighlightTarget = function () {
    const target = this.highlightedTarget;
    this.highlightedTarget = undefined;

    if (target) {
        target.findComponent(MergeComponent).stopHighlight();
    }
};

RainbowComponent.prototype.handleDragEnd = function (rawX, rawY, cancelled) {
    this.unHighlightDrag();
    this.unhighlightTarget();

    const affected = this.findAffectedUnit(rawX, rawY, cancelled);

    if (affected && !cancelled) {
        this.openConfirmation(affected);
        return true;
    }
};

RainbowComponent.prototype.openConfirmation = function (affected) {
    cleverapps.focusManager.display({
        focus: "RainbowConfirmationWindow",
        action: (f) => {
            new RainbowConfirmationWindow(this, affected);
            cleverapps.focusManager.onceNoWindowsListener = f;
        }
    });
};

RainbowComponent.prototype.isAffectedUnit = function (unit) {
    return this.isUpgradable(unit);
};

RainbowComponent.prototype.onWrongTarget = function () {
    Merge2.current.showHint(this.unit.onGetView(), Messages.get("Rainbow.wrongTarget"));
};

RainbowComponent.prototype.isUpgradable = function (unit) {
    return ["resource", "valuables"].includes(unit.getType()) && !Unit.isSideQuest(unit.code)
        && !unit.getData().unmergeable && !unit.isLast() && !unit.isInFog() && !unit.isBlocked();
};

RainbowComponent.prototype.upgrade = function (target) {
    cleverapps.metrics.logEvent(`${cleverapps.EVENTS.BOOSTER_USE}-${this.unit.code}`, { itemId: target.getType() });
    cleverapps.playSession.logEventOnce(`${cleverapps.EVENTS.BOOSTER_USE_DAU}-${this.unit.code}`);

    this.unit.findComponent(MergeComponent).merge([target]);
};

RainbowComponent.prototype.unHighlightDrag = function () {
    if (this.view) {
        this.view.unHighlightDrag();
    }
};

RainbowComponent.prototype.handleRemove = function () {
    this.unHighlightDrag();
    this.unhighlightTarget();
};

RainbowComponent.prototype.destructor = function () {
    this.unHighlightDrag();
    this.unhighlightTarget();
};
